// Platform detection for App-Store-specific UX gates.
//
// Apple rejects builds that reference paid content unless the matching
// IAP product has been submitted alongside the binary. Until our IAPs
// are wired through StoreKit, any "Upgrade to Pro" / pricing copy must
// be HIDDEN on iOS — but stays visible on Android and web.
//
// Web fallback uses the same Capacitor.isNativePlatform() helper App.js
// already relies on, so behaviour is consistent across the codebase.

import { Capacitor } from '@capacitor/core';

export function isNativePlatform() {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
}

export function isIOSApp() {
  try { return Capacitor.getPlatform() === 'ios'; } catch { return false; }
}

// True wherever the App-Store paid-content policy applies. Right now
// that's only iOS, but the helper exists so future stores (e.g. an
// embed in an App-Store-policy partner) can be added in one place.
export function paidContentRestricted() {
  return isIOSApp();
}
